import React from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { changeEventFilter } from '../../../../../store/actions/sportEvents';
import { initialPreMatchFilters } from '../../../../../constants/event-filters';

const Periods = props => {
    const dispatch = useDispatch();

    const periods = useSelector(state => state.sportEvents.filters.periods) || [];

    const options = periods.map(period => ({
        value: period.id,
        label: period.label,
        selected: period.selected,
        getRange: initialPreMatchFilters.periods.find(p => p.id === period.id).getRange,
    }));

    const selectedOption = options.find(option => option.selected);

    const onChange = value => {
        if (value.value === selectedOption.value) return;

        if (props.onChange) {
            props.onChange(value);
        }

        const newPeriods = periods.map(period => ({
            ...period,
            selected: period.id === value.value,
        }));

        dispatch(changeEventFilter({ key: 'periods', value: newPeriods }));
    };

    return (
        <Select
            className='common-select common-select--events'
            classNamePrefix='common'
            menuPlacement={'auto'}
            isSearchable={false}
            value={selectedOption}
            onChange={onChange}
            options={options}
        />
    );
};

export default Periods;
